import { Link } from 'react-router-dom'

/**
 * 404 внутри приложения (wireframe 404.C).
 * Рендерится внутри Layout — у пользователя сохраняется сайдбар, шапка
 * валют и общий контекст CRM. Показывается для несуществующих путей
 * защищённой зоны.
 */
export function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center space-y-4 max-w-md">
        <div className="text-7xl font-bold text-gray-900 tracking-tight select-none">
          4<span className="text-brand-600">0</span>4
        </div>

        <h1 className="text-xl font-semibold text-gray-900">Страница не найдена</h1>

        <p className="text-sm text-gray-500">
          Адрес изменился, страница удалена или у вас нет доступа. Проверьте ссылку или вернитесь к
          работе.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 pt-2">
          <Link
            to="/dashboard"
            className="px-4 py-2 bg-brand-600 hover:bg-brand-700 text-white text-sm font-medium rounded-lg transition-colors"
          >
            На главную
          </Link>
          <Link
            to="/requests"
            className="px-4 py-2 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-lg transition-colors"
          >
            К заявкам
          </Link>
        </div>
      </div>
    </div>
  )
}
